import { Client, Enumerable, ResourceId } from "../types/internal";
import { omitData, omitNil } from "../utils/data";
import { QueryOptions, Service, ServiceBookingQueryStatus } from "../models";
import {
  ServiceAvailabilitySchedule,
  ServiceAvailabilityScheduleOptions,
  ServiceBooking,
  ServiceBookingCancelResponse,
  ServiceBookingInput,
  ServiceBookingResponse,
  ServicesBookingCancelInput,
  ServicesBookingRetrieveOptions,
} from "../models/Bookings";
import { formatDateYMD } from "../utils/date";

export const createService = (client: Client) => ({
  retrieve: (id: ResourceId, fields?: Enumerable<string>) => {
    return client
      .retrieve<Service>(["services", id], fields)
      .then((result) => ({
        ...omitData(result),
        service: result.data,
      }));
  },
  list: (options?: QueryOptions) => {
    return client.list<Service[]>("services", options).then((result) => ({
      ...omitData(result),
      services: result.data,
    }));
  },
  availability: (
    provider: string,
    options: ServiceAvailabilityScheduleOptions = {}
  ): Promise<ServiceAvailabilitySchedule> => {
    let dateFrom: string | undefined, dateTo: string | undefined;

    if (options.date) {
      // dateFrom = dayjs(options.date).format("YYYY-MM-DD");
      // dateTo = dayjs(options.date).endOf("month").format("YYYY-MM-DD");
      const inputDate = new Date(options.date);
      const endOfMonth = new Date(
        inputDate.getFullYear(),
        inputDate.getMonth() + 1,
        0
      );

      dateFrom = formatDateYMD(inputDate);
      dateTo = formatDateYMD(endOfMonth);
    }

    const params = omitNil({
      s: options.service,
      "v[]": options.variants,
      a: options.agent,
      df: dateFrom,
      dt: dateTo,
      tz: options.timezone,
      // r: rescheduleId,
      // d: duration
    });

    return client.get<ServiceAvailabilitySchedule>(
      ["services/availability", provider],
      { params }
    );
  },
  book: (input: ServiceBookingInput) => {
    const data = omitNil({
      ...input,
      date: formatDateYMD(input.date),
    });

    return client
      .post<ServiceBookingResponse>("services/book", { data })
      .catch((error: Error): ServiceBookingResponse => {
        return {
          status: ServiceBookingQueryStatus.ERROR,
          errors: {
            codes: [],
            messages: [error.message],
          },
        };
      });
  },
  getBooking: (options: ServicesBookingRetrieveOptions) => {
    return client.get<ServiceBooking>([
      "services/booking",
      options.reference,
      options.email,
    ]);
  },
  cancelBooking: (data: ServicesBookingCancelInput) => {
    return client.post<ServiceBookingCancelResponse>(
      "services/booking/cancel",
      { data }
    );
  },
});
